import { render, staticRenderFns } from "./ThankYouSingle.vue?vue&type=template&id=941d5ee4"
import script from "./ThankYouSingle.vue?vue&type=script&lang=js"
export * from "./ThankYouSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports